/* eslint react-hooks/exhaustive-deps: "warn" */

import { Link } from 'libs/router/Link';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';

import { AskRegisInput } from 'features/agents/organisms/AskRegisInput/AskRegisInput';

import styles from './HomeHeroSection.module.scss';

const ArrowIcon = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

type HomeHeroSectionProps = {
  freeTrialRoute?: string;
};

export const HomeHeroSection = ({ freeTrialRoute }: HomeHeroSectionProps) => {
  const { t } = useInt();

  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <TitleBlock
          size="page"
          title={t('10 years of sourcing registry data. A whole new way to search.')}
          description={t(
            "We spent a decade sourcing official company data directly from government registries. Now it's available in a completely new way — instantly verify companies, query financials, UBOs and group structure, and pull the original filings across 600M+ companies.",
          )}
        />

        <div className={styles.actions}>
          <Button type="blue" size="xxl" route={freeTrialRoute || '/free-trial'} suffix={<ArrowIcon />}>
            {t('Get Started for Free')}
          </Button>

          <Link route="/data-dictionary" className={styles.link}>
            {t('Explore Our Data')}
          </Link>
        </div>

        <AskRegisInput className={styles.demo} />
      </div>

      <OurCustomersV2 hasBackground={false} className={styles.customers} />
    </section>
  );
};
